<template>
  <section style="margin-bottom: 100px">
    <div class="leftMe">
      <div class="code">
        <div>
          <p>{{ $t("扫码下载APP") }}</p>
          <img :src="image.app_ewm" alt="" />
          <p style="margin: 30px 0">ios</p>
          <img :src="image.wechat_ewm" alt="" />
          <p>{{ $t("小程序") }}</p>
        </div>
      </div>
      <div class="info" v-if="type">
        <div class="info_img" @click="$router.push('/user')" style="cursor: pointer">
          <img src="@/imgs/icon_2.png" alt="" />
          <p>{{ $t("我的") }}</p>
        </div>
        <div class="info_img" @click="kefuClick" style="cursor: pointer">
          <img src="@/imgs/icon_3.png" alt="" />
          <p>{{ $t("客服") }}</p>
        </div>
        <div class="info_img" @click="refresh()" style="cursor: pointer">
          <img src="@/imgs/icon_4.png" alt="" />
          <p>{{ $t("刷新") }}</p>
        </div>
        <div class="info_img" @click="toTop" style="cursor: pointer">
          <img src="@/imgs/icon_5.png" alt="" />
          <p>{{ $t("顶部") }}</p>
        </div>
      </div>
      <div class="customerservice" v-if="kefuShow">
        <div class="clearfix kefu">
          <div class="left">
            <img src="@/imgs/icon_6.png" alt="" />
          </div>
          <div class="left">
            <div>{{ $t("在线客服") }}</div>
            <div class="online" @click="kf">{{ $t("在线咨询") }}</div>
          </div>
        </div>
        <div class="clearfix kefu">
          <div class="left">
            <img src="@/imgs/icon_7.png" alt="" />
          </div>
          <div class="left">
            <div>{{ $t("呼叫客服") }}</div>
            <div>
              <span style="color: #666666; font-size: 12px">{{ $t("热线电话") }}:</span
              ><span style="font-weight: 400; color: #559aff; margin-left: 8px"
                >021-5662455</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
export default {
  name: "showLeft",
  components: {},
  data() {
    return {
      kefuShow: false, //客服隐藏显示
      selectDiv: false, //是否回到顶部
      image: {},
    };
  },
  props: {
    type: {
      type: Boolean,
      default: true,
    },
  },
  inject: ["reload"],
  created() {
    console.log("this.$route.query.userId", this.$route.query.userId);
    this.userofficial = this.$route.query.userId;
    this.post632a64e2cbd05();
  },
  methods: {
    kf() {
      location.href =
        "https://104910.kefu.easemob.com/webim/im.html?configId=374e3e7d-7239-4ae7-bb29-fe5ba4c62898";
    },
    kefuClick() {
      this.kefuShow = !this.kefuShow;
    },
    toTop() {
      console.log(
        "document.documentElement.scrollTop",
        document.documentElement.scrollTop
      );
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      const anchorEle = document.querySelector("#app");
      // console.log("anchorEle", anchorEle);
      if (!!anchorEle) {
        console.log("anchorEle", anchorEle);
        anchorEle.scroll({
          top: anchorEle.offsetTop,
          behavior: "smooth", // 平滑移动
        });
      }
    },
    // 刷新
    refresh() {
      // this.reload();
      this.$router.go(0);
    },
    //获取指定广告位的广告列表
    post632a64e2cbd05() {
      Service.post632a64e2cbd05().then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.image = res.data;
          // this.publicBannerList = res.data
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";

.leftMe {
  // width: 64px;
  // height: 313px;
  position: fixed;
  right: 10px;
  top: 55%;
  transform: translate(0, -50%);
  z-index: 9;
  .code {
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;

    text-align: center;
    padding: 16px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    p:first-child {
      margin-bottom: 8px;
    }
    p:last-child {
      margin-top: 8px;
    }
  }
  .info {
    width: 64px;
    height: 313px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    margin-top: 67px;
    img {
      width: 26px;
      height: 26px;
    }
    .info_img {
      padding-top: 24px;
      margin-top: 0;
      &:first-child {
        margin-top: 16px;
      }
    }
  }
  .customerservice {
    width: 224px;
    // height: 148px;
    position: absolute;
    right: 124px;
    bottom: 67px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    .kefu {
      padding: 16px 17px;
      .online {
        width: 64px;
        height: 27px;
        background: rgba(85, 154, 255, 0.2);
        border-radius: 4px 4px 4px 4px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #559aff;
        text-align: center;
        line-height: 27px;
        margin-top: 4px;
      }
    }
    img {
      width: 34px;
      height: 34px;
      margin-right: 8px;
    }
    // &:hover {
    //     display: none;
    // }
  }
}
.code {
  img {
    width: 84px;
    height: 84px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showLeft/index.vue